import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  // "van {{label}}" keeps the noun at the end, same as the English original.
  loading: 'Bezig met laden van {{label}}…',
  // "Geen toegang tot X" reads better in Dutch than a literal translation
  // and still ends on the noun.
  forbidden: 'Geen toegang tot {{label}}.',
  notFound: '{{label}} is niet gevonden.',
  loadingFailed: 'Laden van {{label}} mislukt: {{message}}',
  submitForbidden: 'Dit mag je niet doen{{suffix}}',
  submitConflict: 'Dit botst met de huidige status{{suffix}}',
  submitGeneric: 'Er ging iets mis: {{message}}',
};
